import { render } from "./EditarFornecedor.vue?vue&type=template&id=2d6b4003"
import script from "./EditarFornecedor.vue?vue&type=script&lang=js"
export * from "./EditarFornecedor.vue?vue&type=script&lang=js"

import "./EditarFornecedor.vue?vue&type=style&index=0&id=2d6b4003&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QForm,QInput,QBtn,QField});
